import { Auth, Hub } from 'aws-amplify'
import { useSession } from 'next-auth/react'
import { useCallback, useEffect, useState } from 'react'

export const useAccessToken = () => {
  const [token, setToken] = useState<string | undefined>(undefined)
  const [initialized, setInitialized] = useState(false)

  // NOTE: useSessionでsessionが取得できる = SNSログイン
  const { data: session, status } = useSession()
  useEffect(() => {
    if (status === 'authenticated') {
      setToken(session?.access_token)
      setInitialized(true)
    } else {
      setToken(undefined)
    }
  }, [session, status])

  const fetchCognitoUser = useCallback(async () => {
    try {
      const session = await Auth.currentSession()
      const token = session.getIdToken().getJwtToken()
      setToken(token)
    } catch {
      setToken(undefined)
    }
    setInitialized(true)
  }, [])

  useEffect(() => {
    fetchCognitoUser()

    const listener = async (data: any) => {
      const { event } = data.payload

      if (event === 'signIn' || event === 'signOut') {
        fetchCognitoUser()
      }
    }

    const cancel = Hub.listen('auth', listener)

    return () => {
      cancel()
    }
  }, [fetchCognitoUser])

  return { token, initialized }
}
